import { render, staticRenderFns } from "./create-form.vue?vue&type=template&id=60786a58&scoped=true&"
import script from "./create-form.vue?vue&type=script&lang=js&"
export * from "./create-form.vue?vue&type=script&lang=js&"
import style0 from "./create-form.vue?vue&type=style&index=0&id=60786a58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60786a58",
  null
  
)

export default component.exports